export default __webpack_public_path__ + "static/media/cert-senior-manager-consumer-sc.c7e55738.jpg";